import { FormEvent, useState } from "react";
import { useAccount } from "../../app/account";
import { checkPassword, PasswordProblem } from "../../core/account/credentials";
import { accountErrorKind, AccountErrorKind } from "../../core/account/types";
import { buttonClass } from "../../components/StatusScreen";
import { en } from "../../i18n/en";
import { Field, FormError } from "./AccountPage";

const t = en.account;

/** Sets the signed-in person's password; used by /welcome and /reset-password (specs/11). */
export function NewPasswordForm({
  label,
  submitLabel,
  onSaved,
}: {
  label: string;
  submitLabel: string;
  onSaved: () => void;
}) {
  const { services } = useAccount();
  const [password, setPassword] = useState("");
  const [problem, setProblem] = useState<PasswordProblem | null>(null);
  const [error, setError] = useState<AccountErrorKind | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    const found = checkPassword(password);
    setProblem(found);
    if (found) return;
    setBusy(true);
    try {
      await services.account.setPassword(password);
      onSaved();
    } catch (err) {
      setError(accountErrorKind(err));
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} noValidate className="flex flex-col gap-4">
      {error && <FormError>{t.errors[error]}</FormError>}
      <Field
        label={label}
        type="password"
        autoComplete="new-password"
        minLength={10}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        hint={t.welcome.passwordHint}
        error={problem && t.passwordErrors[problem]}
      />
      <button type="submit" disabled={busy} className={buttonClass}>
        {submitLabel}
      </button>
    </form>
  );
}
